export interface FeatureSectionProps {
  /** Title of the feature. */
  title: string;

  /** More detailed description of the feature. */
  description: string;

  /** Additional content (e.g., screen recordings) to display. */
  children: React.ReactNode;
}

/**
 * Section highlighting a feature of the app.
 */
export function FeatureSection({
  title,
  description,
  children,
}: FeatureSectionProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <h2 style={{ margin: 0, marginBottom: 5 }}>{title}</h2>
      <p style={{ margin: 0, marginBottom: 25 }}>{description}</p>

      {/* Additional content (e.g., screen recordings) */}
      {children}
    </div>
  );
}
